import { render, staticRenderFns } from "./editMiniGameTemplate.vue?vue&type=template&id=b7190b36&lang=pug"
import script from "./editMiniGameTemplate.vue?vue&type=script&lang=js"
export * from "./editMiniGameTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports